import styled from 'styled-components';
export const Content = styled.div `
  position: relative;
  z-index: 2;
  color: white;
  
  .tag, .btn {
    margin: 1.5rem 0 0;
  }
`;
export const Header = styled.span `
  font: var(--heading-three-font);
  color: white;
  display: block;
`;
export const Copy = styled.span `
  display: block;
  color: white;
  margin-top: 1.5rem;
`;
export default {
    Content,
};
